import { LitElement, html, nothing } from 'lit';
import { property, customElement, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { ifDefined } from 'lit/directives/if-defined.js';
import { GzTooltipWebComponent } from '../../gzTooltip';
import { GzTextWebComponent } from '../../gzText';
import { isEmpty } from '@nirvana/shared/basic-types/object';
import { FontSizes } from '../../../types/common/types';
import { formatLargeNumber } from '../../../utils/formatter.utils';

@customElement('gz-inventory-item')
export class GzInventoryItemWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  label: string;

  @property({ type: String, attribute: true, reflect: true })
  icon: string;

  @property({ type: Number, attribute: true, reflect: true })
  value: number;

  @property({ type: Number, attribute: true, reflect: true })
  labelSize = FontSizes.PARAGRAPH_12;

  @property({ type: Number, attribute: true, reflect: true })
  iconSize = FontSizes.BODY;

  @query('#inventoryWrapper')
  private wrapper: HTMLElement;

  @query('#label')
  private inventoryLabel: GzTextWebComponent;

  @query('#tooltip')
  private tooltip: GzTooltipWebComponent;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div id="inventoryWrapper" class="inventory-item-wrapper d-flex justify-center align-items-center">
        <gz-tooltip
          id="tooltip"
          .tooltipText="${!isEmpty(this.value) ? this.label : nothing}"
          class="inventory-tooltip"
        >
          <span class="inventory-icon ${ifDefined(this.icon)}"></span>
        </gz-tooltip>
        <gz-text id="label" fontSize="${this.labelSize}" class="inventory-label"
          >${!isEmpty(this.label) ? this.label : '...'}</gz-text
        >
        <gz-text fontSize="${this.labelSize}" fontWeight="700" class="inventory-value"
          ><span>${!isEmpty(this.value) ? formatLargeNumber(this.value) : '_'}</span></gz-text
        >
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-inventory-item': GzInventoryItemWebComponent;
  }
}
